/**
 * Call/put from an option symbol. Covers OCC (SPY260612C00739000), TradeStation
 * (SPY 260612C739), dotted (.SPY260612C739) and O:-prefixed variants.
 * @returns {'Call'|'Put'|null}
 */
export function optionRight(symbol) {
  const s = String(symbol || '').trim().toUpperCase().replace(/\s+/g, '').replace(/^(O:|\.)/, '');
  const m = s.match(/^[A-Z.]{1,6}\d{6}([CP])\d+(\.\d+)?$/);
  if (!m) return null;
  return m[1] === 'C' ? 'Call' : 'Put';
}

/** "Long Put" for options, plain "Long"/"Short" otherwise. */
export function tradeDirectionLabel(direction, symbol) {
  if (!direction) return direction;
  const right = optionRight(symbol);
  return right ? `${direction} ${right}` : direction;
}
